import clsx from 'clsx';
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../common/css/timeLive.css'
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import { getValueFromResource } from './timeLiveFunction';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { KTIcon } from '../_metronic/helpers';
import { UncheckedshowAdminPagesState } from './GlobalSlice';


interface MenuItem {
    SystemSecurityCategoryPageId: number;
    SystemCategoryPageDescription: string;
    SystemCategoryPageFrontEnd: string;
    ParentSystemSecurityCategoryPageBreadCrumbId?: number;
}

interface BreadcrumbsProps {
    currentPath: string;
    menuItems: MenuItem[];
    id: any;
    ProjectTaskId?: any;
}

const taskBreadCrum = [
    {
        "SystemSecurityCategoryPageId": 28,
        "SystemCategoryPageFrontEnd": "mytasks",
        "SystemCategoryPageDescription": "My Task",
        "SystemSecurityCategoryPageSectionId": 15,
        "SystemSecurityCategoryPageSectionName": "Projects",
        "SystemSecurityCategoryPageSectionIcon": "add-folder",
        "SystemSecurityCategoryId": 1,
        "SystemSecurityCategory": "Admin Pages",
        "ParentSystemSecurityCategoryPageBreadCrumbId": null,
        "Folder": "ProjectAdmin",
        "SystemFeatureId": null
    },
    {
        "SystemSecurityCategoryPageId": 173,
        "SystemCategoryPageFrontEnd": "accountprojecttasksummary",
        "SystemCategoryPageDescription": "Task Summary",
        "SystemSecurityCategoryPageSectionId": 15,
        "SystemSecurityCategoryPageSectionName": "Projects",
        "SystemSecurityCategoryPageSectionIcon": "add-folder",
        "SystemSecurityCategoryId": 1,
        "SystemSecurityCategory": "Admin Pages",
        "ParentSystemSecurityCategoryPageBreadCrumbId": 171,
        "Folder": "ProjectAdmin",
        "SystemFeatureId": null
    }
]

let projectTemplate = [
    {
        "SystemSecurityCategoryPageId": 103,
        "SystemCategoryPageFrontEnd": "accountprojecttemplates",
        "SystemCategoryPageDescription": "Project Templates",
        "SystemSecurityCategoryPageSectionId": 4,
        "SystemSecurityCategoryPageSectionName": "Project / Task Setup",
        "SystemSecurityCategoryPageSectionIcon": "questionnaire-tablet",
        "SystemSecurityCategoryId": 1,
        "SystemSecurityCategory": "Admin Pages",
        "ParentSystemSecurityCategoryPageBreadCrumbId": null,
        "Folder": "ProjectAdmin",
        "SystemFeatureId": "27d3a272-d849-4942-9985-7672fb582389"
    },
    {
        "SystemSecurityCategoryPageId": 171,
        "SystemCategoryPageFrontEnd": "accountprojectsummary",
        "SystemCategoryPageDescription": "Project Summary",
        "SystemSecurityCategoryPageSectionId": 15,
        "SystemSecurityCategoryPageSectionName": "Projects",
        "SystemSecurityCategoryPageSectionIcon": "add-folder",
        "SystemSecurityCategoryId": 1,
        "SystemSecurityCategory": "Admin Pages",
        "ParentSystemSecurityCategoryPageBreadCrumbId": 31,
        "Folder": "ProjectAdmin",
        "SystemFeatureId": null
    }
]

let billingRateBreadcrums = [
    {
        "SystemSecurityCategoryPageId": 31,
        "SystemCategoryPageFrontEnd": "projects",
        "SystemCategoryPageDescription": "Projects",
        "SystemSecurityCategoryPageSectionId": 15,
        "SystemSecurityCategoryPageSectionName": "Projects",
        "SystemSecurityCategoryPageSectionIcon": "add-folder",
        "SystemSecurityCategoryId": 1,
        "SystemSecurityCategory": "Admin Pages",
        "ParentSystemSecurityCategoryPageBreadCrumbId": null,
        "Folder": "ProjectAdmin",
        "SystemFeatureId": null
    },
    {
        "SystemSecurityCategoryPageId": 171,
        "SystemCategoryPageFrontEnd": "accountprojectsummary",
        "SystemCategoryPageDescription": "Project Summary",
        "SystemSecurityCategoryPageSectionId": 15,
        "SystemSecurityCategoryPageSectionName": "Projects",
        "SystemSecurityCategoryPageSectionIcon": "add-folder",
        "SystemSecurityCategoryId": 1,
        "SystemSecurityCategory": "Admin Pages",
        "ParentSystemSecurityCategoryPageBreadCrumbId": null,
        "Folder": "ProjectAdmin",
        "SystemFeatureId": null
    },
    {
        "SystemSecurityCategoryPageId": 173,
        "SystemCategoryPageFrontEnd": "accountprojecttasksummary",
        "SystemCategoryPageDescription": "Task Summary",
        "SystemSecurityCategoryPageSectionId": 15,
        "SystemSecurityCategoryPageSectionName": "Projects",
        "SystemSecurityCategoryPageSectionIcon": "add-folder",
        "SystemSecurityCategoryId": 1,
        "SystemSecurityCategory": "Admin Pages",
        "ParentSystemSecurityCategoryPageBreadCrumbId": null,
        "Folder": "ProjectAdmin",
        "SystemFeatureId": null
    },
    {
        "SystemSecurityCategoryPageId": 95,
        "SystemCategoryPageFrontEnd": "accountbillingrate",
        "SystemCategoryPageDescription": "Billing Rate",
        "SystemSecurityCategoryPageSectionId": 15,
        "SystemSecurityCategoryPageSectionName": "Projects",
        "SystemSecurityCategoryPageSectionIcon": "add-folder",
        "SystemSecurityCategoryId": 1,
        "SystemSecurityCategory": "Admin Pages",
        "ParentSystemSecurityCategoryPageBreadCrumbId": 4,
        "Folder": "AccountAdmin",
        "SystemFeatureId": null
    }
]

const BreadCrumbs: React.FC<BreadcrumbsProps> = ({ currentPath, menuItems, id, ProjectTaskId }) => {
    // Function to get breadcrumb trail for the current path
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { AccountEmployeeDashboardId, OpenInNewTab } = useAppSelector((state) => state.globalState);
    const queryParams = new URLSearchParams(location.search);
    const fromValue = queryParams.get('from');
    const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
    const IsFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");
    const storedObjectData = localStorage.getItem('objTask');

    const objectData = storedObjectData ? JSON.parse(storedObjectData) : {};
    const AccountProjectTaskId: any = objectData.AccountProjectTaskId;
    const AccountProjectId = objectData.AccountProjectId;
    const navigate = useNavigate();
    const dataParam = queryParams.get('data');

    let isFromDashboard = false;
    if (dataParam) {
        try {
            const decodedData = JSON.parse(decodeURIComponent(dataParam));
            isFromDashboard = decodedData.fromDashboard === true;
        } catch (e) {
            isFromDashboard = false;
        }
    }
    const returnToDashboardUrl = localStorage.getItem('returnToDashboard') || "/dashboard";


    const getBreadcrumbs = (path: string): MenuItem[] => {
        const breadcrumbs: MenuItem[] = [];
        const currentMenuItem = menuItems.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === path);
        if (currentMenuItem) {
            breadcrumbs.unshift(currentMenuItem); // Add current menu item to breadcrumbs array

            // Traverse up the hierarchy using parentId until we reach the top level
            let parentId = currentMenuItem.ParentSystemSecurityCategoryPageBreadCrumbId;
            while (parentId !== undefined) {
                const parentMenuItem = menuItems.find(item => item.SystemSecurityCategoryPageId === parentId);
                if (parentMenuItem) {
                    breadcrumbs.unshift(parentMenuItem);
                    parentId = parentMenuItem.ParentSystemSecurityCategoryPageBreadCrumbId;
                } else {
                    break;
                }
            }
        }

        return breadcrumbs;
    };

    // Get the breadcrumbs for the current path
    // const breadcrumbs = getBreadcrumbs(currentPath);
    let breadcrumbs = [];
    if (fromValue === 'mytask') {
        breadcrumbs = taskBreadCrum
    } else if (fromValue === 'projectTemplate') {
        breadcrumbs = projectTemplate;
    } else if (fromValue === 'projectTemplateTask') {
        breadcrumbs = [
            ...projectTemplate,
            {
                "SystemSecurityCategoryPageId": 173,
                "SystemCategoryPageFrontEnd": "accountprojecttasksummary",
                "SystemCategoryPageDescription": "Task Summary",
                "SystemSecurityCategoryPageSectionId": 15,
                "SystemSecurityCategoryPageSectionName": "Project Summary",
                "SystemSecurityCategoryPageSectionIcon": "add-folder",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 171,
                "Folder": "ProjectAdmin",
                "SystemFeatureId": null
            }
        ];
    } else if (fromValue === 'templateToTeam') {
        breadcrumbs = [
            {
                "SystemSecurityCategoryPageId": 103,
                "SystemCategoryPageFrontEnd": "accountprojecttemplates",
                "SystemCategoryPageDescription": "Project Templates",
                "SystemSecurityCategoryPageSectionId": 4,
                "SystemSecurityCategoryPageSectionName": "Project / Task Setup",
                "SystemSecurityCategoryPageSectionIcon": "questionnaire-tablet",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": null,
                "Folder": "ProjectAdmin",
                "SystemFeatureId": "27d3a272-d849-4942-9985-7672fb582389"
            },
            {
                "SystemSecurityCategoryPageId": 158,
                "SystemCategoryPageFrontEnd": "projecttaskteam",
                "SystemCategoryPageDescription": "Task Employees",
                "SystemSecurityCategoryPageSectionId": 15,
                "SystemSecurityCategoryPageSectionName": "Projects",
                "SystemSecurityCategoryPageSectionIcon": "add-folder",
                "SystemSecurityCategoryId": 3,
                "SystemSecurityCategory": "Project Manager Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 173,
                "Folder": "ProjectAdmin",
                "SystemFeatureId": null
            }
        ];
    } else if (fromValue === 'projectTemplateTeam') {
        breadcrumbs = [
            ...projectTemplate,
            {
                "SystemSecurityCategoryPageId": 173,
                "SystemCategoryPageFrontEnd": "accountprojecttasksummary",
                "SystemCategoryPageDescription": "Task Summary",
                "SystemSecurityCategoryPageSectionId": 15,
                "SystemSecurityCategoryPageSectionName": "Project Summary",
                "SystemSecurityCategoryPageSectionIcon": "add-folder",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 171,
                "Folder": "ProjectAdmin",
                "SystemFeatureId": null
            },
            {
                "SystemSecurityCategoryPageId": 158,
                "SystemCategoryPageFrontEnd": "projecttaskteam",
                "SystemCategoryPageDescription": "Task Employees",
                "SystemSecurityCategoryPageSectionId": 15,
                "SystemSecurityCategoryPageSectionName": "Projects",
                "SystemSecurityCategoryPageSectionIcon": "add-folder",
                "SystemSecurityCategoryId": 3,
                "SystemSecurityCategory": "Project Manager Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 173,
                "Folder": "ProjectAdmin",
                "SystemFeatureId": null
            }
        ];
    } else if (fromValue === 'templateTeam') {
        breadcrumbs = [
            ...projectTemplate,
            {
                "SystemSecurityCategoryPageId": 88,
                "SystemCategoryPageFrontEnd": "projectteam",
                "SystemCategoryPageDescription": "Project Employees",
                "SystemSecurityCategoryPageSectionId": 15,
                "SystemSecurityCategoryPageSectionName": "Projects",
                "SystemSecurityCategoryPageSectionIcon": "add-folder",
                "SystemSecurityCategoryId": 3,
                "SystemSecurityCategory": "Project Manager Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 31,
                "Folder": "ProjectAdmin",
                "SystemFeatureId": null
            }
        ];
    } else if (fromValue === 'scheduleCustomize') {
        breadcrumbs = [
            {
                "SystemSecurityCategoryPageId": 124,
                "SystemCategoryPageFrontEnd": "myreports",
                "SystemCategoryPageDescription": "My Reports",
                "SystemSecurityCategoryPageSectionId": 24,
                "SystemSecurityCategoryPageSectionName": "Reports local",
                "SystemSecurityCategoryPageSectionIcon": "people",
                "SystemSecurityCategoryId": 6,
                "SystemSecurityCategory": "Users Reports",
                "ParentSystemSecurityCategoryPageBreadCrumbId": null,
                "Folder": "WebReport",
                "SystemFeatureId": null
            },
            {
                "SystemSecurityCategoryPageId": 126,
                "SystemCategoryPageFrontEnd": "customreportview",
                "SystemCategoryPageDescription": "Show Report",
                "SystemSecurityCategoryPageSectionId": 1,
                "SystemSecurityCategoryPageSectionName": "Organization Setup",
                "SystemSecurityCategoryPageSectionIcon": "share",
                "SystemSecurityCategoryId": 6,
                "SystemSecurityCategory": "Users Reports",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 124,
                "Folder": "WebReport",
                "SystemFeatureId": null
            },
            {
                "SystemSecurityCategoryPageId": 127,
                "SystemCategoryPageFrontEnd": "customreportdesign",
                "SystemCategoryPageDescription": "Report Design",
                "SystemSecurityCategoryPageSectionId": 1,
                "SystemSecurityCategoryPageSectionName": "Organization Setup",
                "SystemSecurityCategoryPageSectionIcon": "share",
                "SystemSecurityCategoryId": 6,
                "SystemSecurityCategory": "Users Reports",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 124,
                "Folder": "WebReport",
                "SystemFeatureId": null
            }
        ];
    } else if (fromValue === 'zonelist') {
        breadcrumbs = [
            {
                "SystemSecurityCategoryPageId": 513,
                "SystemCategoryPageFrontEnd": "geofenceZone",
                "SystemCategoryPageDescription": "Geofence Zone",
                "SystemSecurityCategoryPageSectionId": 28,
                "SystemSecurityCategoryPageSectionName": "Geofence Setup",
                "SystemSecurityCategoryPageSectionIcon": "map",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": null,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "a8c66b2b-db46-404d-a83f-fe797d349788"
            },
            {
                "SystemSecurityCategoryPageId": 514,
                "SystemCategoryPageFrontEnd": "geofenceZone",
                "SystemCategoryPageDescription": "Edit Geofence Zone",
                "SystemSecurityCategoryPageSectionId": 28,
                "SystemSecurityCategoryPageSectionName": "Geofence Setup",
                "SystemSecurityCategoryPageSectionIcon": "map",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 513,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "a8c66b2b-db46-404d-a83f-fe797d349788"
            }
        ]
    } else if (currentPath.toLowerCase() === 'geofencing') {
        breadcrumbs = [
            {
                "SystemSecurityCategoryPageId": 513,
                "SystemCategoryPageFrontEnd": "geofenceZone",
                "SystemCategoryPageDescription": "Geofence Zone",
                "SystemSecurityCategoryPageSectionId": 28,
                "SystemSecurityCategoryPageSectionName": "Geofence Setup",
                "SystemSecurityCategoryPageSectionIcon": "map",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": null,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "a8c66b2b-db46-404d-a83f-fe797d349788"
            },
            {
                "SystemSecurityCategoryPageId": 514,
                "SystemCategoryPageFrontEnd": "geofenceZone",
                "SystemCategoryPageDescription": "Add Geofence Zone",
                "SystemSecurityCategoryPageSectionId": 28,
                "SystemSecurityCategoryPageSectionName": "Geofence Setup",
                "SystemSecurityCategoryPageSectionIcon": "map",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 513,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "a8c66b2b-db46-404d-a83f-fe797d349788"
            }
        ]
    } else if (fromValue === 'profileList') {
        breadcrumbs = [
            {
                "SystemSecurityCategoryPageId": 514,
                "SystemCategoryPageFrontEnd": "geofenceProfile",
                "SystemCategoryPageDescription": "Geofence Profile",
                "SystemSecurityCategoryPageSectionId": 28,
                "SystemSecurityCategoryPageSectionName": "Geofence Setup",
                "SystemSecurityCategoryPageSectionIcon": "map",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": null,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "a8c66b2b-db46-404d-a83f-fe797d349788"
            },
            {
                "SystemSecurityCategoryPageId": 516,
                "SystemCategoryPageFrontEnd": "addGeofenceProfile",
                "SystemCategoryPageDescription": "Edit Geofence Profile",
                "SystemSecurityCategoryPageSectionId": 22,
                "SystemSecurityCategoryPageSectionName": "Others",
                "SystemSecurityCategoryPageSectionIcon": "people",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 514,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "21e65278-ab96-42c6-a332-16cafbbc669e"
            }
        ]
    } else if (currentPath.toLowerCase() === 'addgeofenceprofile') {
        breadcrumbs = [
            {
                "SystemSecurityCategoryPageId": 514,
                "SystemCategoryPageFrontEnd": "geofenceProfile",
                "SystemCategoryPageDescription": "Geofence Profile",
                "SystemSecurityCategoryPageSectionId": 28,
                "SystemSecurityCategoryPageSectionName": "Geofence Setup",
                "SystemSecurityCategoryPageSectionIcon": "map",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": null,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "a8c66b2b-db46-404d-a83f-fe797d349788"
            },
            {
                "SystemSecurityCategoryPageId": 516,
                "SystemCategoryPageFrontEnd": "addGeofenceProfile",
                "SystemCategoryPageDescription": "Add Geofence Profile",
                "SystemSecurityCategoryPageSectionId": 22,
                "SystemSecurityCategoryPageSectionName": "Others",
                "SystemSecurityCategoryPageSectionIcon": "people",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 514,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "21e65278-ab96-42c6-a332-16cafbbc669e"
            }
        ]
    } else if (currentPath.toLowerCase() === 'geofencing') {
        breadcrumbs = [
            {
                "SystemSecurityCategoryPageId": 513,
                "SystemCategoryPageFrontEnd": "geofenceZone",
                "SystemCategoryPageDescription": "Geofence Zone",
                "SystemSecurityCategoryPageSectionId": 28,
                "SystemSecurityCategoryPageSectionName": "Geofence Setup",
                "SystemSecurityCategoryPageSectionIcon": "map",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": null,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "a8c66b2b-db46-404d-a83f-fe797d349788"
            },
            {
                "SystemSecurityCategoryPageId": 514,
                "SystemCategoryPageFrontEnd": "geofenceZone",
                "SystemCategoryPageDescription": "Add Geofence Zone",
                "SystemSecurityCategoryPageSectionId": 28,
                "SystemSecurityCategoryPageSectionName": "Geofence Setup",
                "SystemSecurityCategoryPageSectionIcon": "map",
                "SystemSecurityCategoryId": 1,
                "SystemSecurityCategory": "Admin Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 513,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "a8c66b2b-db46-404d-a83f-fe797d349788"
            }
        ]
    } else if (currentPath.toLowerCase() === 'assignedschedulehours') {
        breadcrumbs = [
            {
                "SystemSecurityCategoryPageId": 509,
                "SystemCategoryPageFrontEnd": "schedule",
                "SystemCategoryPageDescription": "Schedule",
                "SystemSecurityCategoryPageSectionId": 27,
                "SystemSecurityCategoryPageSectionName": "Schedule",
                "SystemSecurityCategoryPageSectionIcon": "schedule",
                "SystemSecurityCategoryId": 2,
                "SystemSecurityCategory": "User Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": null,
                "Folder": "Employee",
                "SystemFeatureId": "444fed58-16e0-49a4-8e42-b0e01c5e569b"
            },
            {
                "SystemSecurityCategoryPageId": 519,
                "SystemCategoryPageFrontEnd": "schedule",
                "SystemCategoryPageDescription": "Scheduled vs Tracked Hours",
                "SystemSecurityCategoryPageSectionId": 0,
                "SystemSecurityCategoryPageSectionName": "Schedule",
                "SystemSecurityCategoryPageSectionIcon": "schedule",
                "SystemSecurityCategoryId": 2,
                "SystemSecurityCategory": "User Pages",
                "ParentSystemSecurityCategoryPageBreadCrumbId": 509,
                "Folder": "AccountAdmin",
                "SystemFeatureId": "21e65278-ab96-42c6-a332-16cafbbc669e"
            }
        ]
    } else if (fromValue === 'summary') {
        const fullBreadcrumbs = billingRateBreadcrums;

        const currentIndex = fullBreadcrumbs.findIndex(
            item => item.SystemCategoryPageFrontEnd.toLowerCase() === currentPath.toLowerCase()
        );

        if (currentIndex !== -1) {
            breadcrumbs = fullBreadcrumbs.slice(0, currentIndex + 1);
        } else {
            breadcrumbs = fullBreadcrumbs;
        }
    } else {
        breadcrumbs = getBreadcrumbs(currentPath);
    }
    breadcrumbs = breadcrumbs.map((item: any) => {
        if (item.SystemCategoryPageFrontEnd === 'accountprojectsummary' && fromValue === 'summary') {
            return { ...item, SystemCategoryPageFrontEnd: `${item.SystemCategoryPageFrontEnd}/${AccountProjectId}` };
        }

        if (item.SystemCategoryPageFrontEnd === 'accountprojecttasksummary' && fromValue === 'summary') {
            return { ...item, SystemCategoryPageFrontEnd: `${item.SystemCategoryPageFrontEnd}/${AccountProjectId}/${AccountProjectTaskId}` };
        }

        if (item.SystemCategoryPageFrontEnd === 'accountprojectsummary') {
            return { ...item, SystemCategoryPageFrontEnd: `${item.SystemCategoryPageFrontEnd}/${id}` };
        }

        if (item.SystemCategoryPageFrontEnd === 'accountprojecttasksummary') {
            return { ...item, SystemCategoryPageFrontEnd: `${item.SystemCategoryPageFrontEnd}/${id}/${AccountProjectTaskId}` };
        }

        if (item.SystemCategoryPageFrontEnd === 'customreportview') {
            return { ...item, SystemCategoryPageFrontEnd: `${item.SystemCategoryPageFrontEnd}/${id}` };
        }
        return item;
    });

    return (
        <>
            <nav aria-label="breadcrumb">
                <ol className={`breadcrumb ${isFromDashboard && !OpenInNewTab ? 'mt-3' : 'mt-6'}`} style={{ marginRight: '5px' }}>
                    {isFromDashboard && !OpenInNewTab && (

                        <li className="breadcrumb-item d-flex align-items-center">
                            <Link
                                to={returnToDashboardUrl}
                                style={{ textDecoration: 'none' }}
                            >
                                <div
                                    className="btn btn-primary  btn-bs-btn-font-weight btn-sm text-white"
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: 500
                                    }}
                                >
                                    <i className="bi bi-arrow-left me-2 fs-5 text-white"></i>
                                    {'Back to Dashboard'}
                                </div>
                            </Link>
                        </li>

                    )}
                    {/* <li className="breadcrumb-item" >
                        <Link to={(licenseExpireFlag === "true" || IsFreeLicenseExpired === "true") ? "/expiry" : "/dashboard"} data-tooltip-id="tooltip-Description"
                       
                        >
                            
                            <i className="bi bi-house-door iconColor" style={{ marginRight: '5px' }}></i>
                            {getValueFromResource('Home', dispatch, t)}
                        </Link>
                    </li> */}
                    <li className="breadcrumb-item">
                        <Link
                            to={(licenseExpireFlag === "true" || IsFreeLicenseExpired === "true") ? "/expiry" : "/dashboard"}
                            data-tooltip-id="tooltip-Description"
                            onClick={() => {
                                // 1. Purani task details local storage se remove karein
                                localStorage.removeItem('objTask');
                                localStorage.removeItem('returnToDashboard');

                                // 2. Redux action dispatch karein jo Admin Pages ko band karti hai (Aapka menu issue solve karega)
                                // Note: Ensure karlein ke 'UncheckedshowAdminPagesState' aapki file ke top par imported ho
                                dispatch(UncheckedshowAdminPagesState());
                            }}
                        >
                            <i className="bi bi-house-door iconColor" style={{ marginRight: '5px' }}></i>
                            {getValueFromResource('Home', dispatch, t)}
                        </Link>
                    </li>
                    {breadcrumbs.map((breadcrumb, index) => {
                        // if (breadcrumb.SystemSecurityCategoryPageId === 28 || breadcrumb.SystemCategoryPageFrontEnd.toLowerCase() === 'accountprojecttasksummary') {

                        // }
                        let basePath = breadcrumb.SystemCategoryPageFrontEnd !== "" ? breadcrumb.SystemCategoryPageFrontEnd.toLowerCase() : "/dashboard";
                        if ((fromValue === 'projectTemplateTask' || fromValue === 'templateTeam') && breadcrumb.SystemCategoryPageDescription === 'Project Summary') {
                            basePath += '?from=projectTemplate';
                        }
                        if (fromValue === 'projectTemplateTeam' && breadcrumb.SystemCategoryPageDescription === 'Task Summary') {
                            basePath += '?from=projectTemplateTask';
                        }
                        if (fromValue === 'summary' && (breadcrumb.SystemCategoryPageFrontEnd.includes('accountbillingrate') || breadcrumb.SystemCategoryPageFrontEnd.includes('accountprojecttasksummary'))) {
                            basePath += '?from=summary';
                        }
                        return (
                            <li
                                className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'current-page' : ''}`}
                                key={breadcrumb.SystemSecurityCategoryPageId}
                                // data-tooltip-id="tooltip-Description"
                                // data-tooltip-content={breadcrumb.SystemCategoryPageDescription}
                                // data-tooltip-place="bottom"
                                style={{ marginLeft: '-5px' }}
                            >
                                {index === breadcrumbs.length - 1 ? (
                                    <>
                                        <span className='card-title fw-bold'>{getValueFromResource(breadcrumb.SystemCategoryPageDescription, dispatch, t)}</span>
                                    </>
                                ) : (
                                    <Link to={basePath}>
                                        {getValueFromResource(breadcrumb.SystemCategoryPageDescription, dispatch, t)}
                                    </Link>
                                    // <Link to={breadcrumb.SystemCategoryPageFrontEnd !== "" ? breadcrumb.SystemCategoryPageFrontEnd.toLowerCase() : "/dashboard"}>
                                    //     {getValueFromResource(breadcrumb.SystemCategoryPageDescription, dispatch, t)}
                                    // </Link>
                                )}
                            </li>
                            // <li
                            //     className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'current-page' : ''}`}
                            //     key={breadcrumb.SystemSecurityCategoryPageId}

                            // >
                            //     {index === breadcrumbs.length - 1 ? (
                            //         <>
                            //             <span className='card-title fw-bold'>{breadcrumb.SystemCategoryPageDescription}</span>
                            //         </>
                            //     ) : (
                            //         <Link to={breadcrumb.SystemCategoryPageFrontEnd !== "" ? breadcrumb.SystemCategoryPageFrontEnd.toLowerCase() : "/timesheet"}>
                            //             {breadcrumb.SystemCategoryPageDescription}
                            //         </Link>
                            //     )}
                            // </li>
                        )
                    })}
                </ol>

            </nav>
            <Tooltip id="tooltip-Description"
                style={{ fontSize: 12, fontWeight: 'normal', padding: 8, borderRadius: 6, fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }}
            />
        </>
    );
};


export default BreadCrumbs;

// import React from 'react';
// import { useTranslation } from 'react-i18next';

// interface MenuItem {
//     SystemCategoryPageFrontEnd: string;
//     SystemSecurityCategoryPageId: number;
//     ParentSystemSecurityCategoryPageBreadCrumbId?: number;
//     // Other properties of MenuItem
// }

// interface BreadcrumbsProps {
//     currentPath: string;
//     menuItems: MenuItem[];
// }

// const BreadCrumbs: React.FC<BreadcrumbsProps> = ({ currentPath, menuItems }) => {
//     const { t } = useTranslation();

//     // Function to get breadcrumb trail for the current path
//     const getBreadcrumbs = (path: string): MenuItem[] => {
//         const breadcrumbs: MenuItem[] = [];
//         const currentMenuItem = menuItems.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === path);

//         if (currentMenuItem) {
//             breadcrumbs.unshift(currentMenuItem);

//             let parentId = currentMenuItem.ParentSystemSecurityCategoryPageBreadCrumbId;
//             while (parentId !== undefined) {
//                 const parentMenuItem = menuItems.find(item => item.SystemSecurityCategoryPageId === parentId);
//                 if (parentMenuItem) {
//                     breadcrumbs.unshift(parentMenuItem);
//                     parentId = parentMenuItem.ParentSystemSecurityCategoryPageBreadCrumbId;
//                 } else {
//                     break;
//                 }
//             }
//         }

//         return breadcrumbs;
//     };

//     // Get the breadcrumbs for the current path
//     const breadcrumbs = getBreadcrumbs(currentPath);

//     return (
//         <nav aria-label="breadcrumb">
//             <ol className="breadcrumb">
//                 {breadcrumbs.map((breadcrumb, index) => (
//                     <li key={index} className="breadcrumb-item">
//                         {t(breadcrumb.SystemCategoryPageFrontEnd)} {/* Assuming SystemCategoryPageFrontEnd is the key to translate */}
//                     </li>
//                 ))}
//             </ol>
//         </nav>
//     );
// };

// export default BreadCrumbs;